import ApiClient from '@/ApiClient';

// Singleton in-flight cache — deduplicates concurrent requests with the same key.
// Exported as a composable for consistent API, but state is shared across all callers.
let inFlightKey = null;
let inFlightPromise = null;

export default function useAdoptionMetricsCache() {
  const getAdoptionMetrics = (timeSeries, divisionId, from, to) => {
    const key = `${timeSeries}:${divisionId ?? ''}:${from ?? ''}:${to ?? ''}`;
    if (inFlightPromise && inFlightKey === key) {
      return inFlightPromise;
    }
    inFlightKey = key;
    inFlightPromise = ApiClient.getAdoptionMetrics(timeSeries, divisionId, from, to).finally(() => {
      if (inFlightKey === key) {
        inFlightKey = null;
        inFlightPromise = null;
      }
    });
    return inFlightPromise;
  };

  return { getAdoptionMetrics };
}
